class DurationDisplayCtrl {
  constructor(Utils) {
    'ngInject';

    Object.assign(this, { Utils });
  }

  $onChanges() {
    const { formatNumber, roundNumber, getDisplayDuration, getDecimalFormat } = this.Utils;

    const minutes = Number(this.minutes);
    if (Number.isNaN(minutes)) {
      this.label = this.default;
      return;
    }

    const defaultZeroLabel = this.asDecimal ? 0 : '0min';
    const zeroLabel = this.displayZero ? defaultZeroLabel : this.default;

    if (minutes === 0) {
      this.label = zeroLabel;
      return;
    }

    const decimalFormat = getDecimalFormat();
    this.label = this.asDecimal
      ? formatNumber(roundNumber(minutes / 60), decimalFormat)
      : getDisplayDuration(
          Math.round(minutes),
          decimalFormat,
          undefined,
          /* allowNegative */ this.allowNegative || this.delta,
          /* showExplicitSign */ this.delta
        );
  }

  get className() {
    if (!this.delta || !this.minutes || this.noColor) {
      return '';
    }

    const positiveNumberClass = this.deltaColorsReversed
      ? 'color-brand-danger'
      : 'color-brand-success';
    const nagativeNumberClass = this.deltaColorsReversed
      ? 'color-brand-success'
      : 'color-brand-danger';

    return this.minutes > 0 ? positiveNumberClass : nagativeNumberClass;
  }
}

export default {
  bindings: {
    minutes: '<',
    delta: '<',
    allowNegative: '<',
    default: '@?',
    displayZero: '<?',
    asDecimal: '<?',
    deltaColorsReversed: '<?',
    noColor: '<?',
  },
  template: '<span ng-class="ctrl.className">{{ctrl.label}}</span>',
  controllerAs: 'ctrl',
  controller: DurationDisplayCtrl,
};
